var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownChevron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50183 10.3675L12.2685 6.59414C12.331 6.53217 12.3806 6.45843 12.4144 6.37719C12.4483 6.29595 12.4657 6.20882 12.4657 6.12081C12.4657 6.0328 12.4483 5.94566 12.4144 5.86442C12.3806 5.78318 12.331 5.70945 12.2685 5.64747C12.1436 5.52331 11.9746 5.45361 11.7985 5.45361C11.6224 5.45361 11.4534 5.52331 11.3285 5.64747L7.99517 8.94748L4.69517 5.64747C4.57026 5.52331 4.40129 5.45361 4.22517 5.45361C4.04904 5.45361 3.88008 5.52331 3.75517 5.64747C3.69217 5.70922 3.64206 5.78285 3.60773 5.8641C3.5734 5.94535 3.55553 6.0326 3.55517 6.12081C3.55553 6.20901 3.5734 6.29627 3.60773 6.37752C3.64206 6.45877 3.69217 6.5324 3.75517 6.59414L7.52183 10.3675C7.58426 10.4351 7.66003 10.4892 7.74436 10.5261C7.82869 10.563 7.91977 10.5821 8.01183 10.5821C8.1039 10.5821 8.19497 10.563 8.2793 10.5261C8.36364 10.4892 8.4394 10.4351 8.50183 10.3675V10.3675Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownChevron);
export default __webpack_public_path__ + "static/media/DownChevron.3da190d1a408b54f3d80b783bfb01fc7.svg";
export { ForwardRef as ReactComponent };